import {
  GET_PICKLIST,
  GET_PICKLIST_SUCCESS,
  GET_PICKLIST_ERROR,
} from "../actions/picklistActions";

interface PicklistState {
  picklist: unknown;
  fetchingPicklist: boolean;
  fetchPicklistComplete: boolean;
  fetchPicklistError: unknown;
}

interface PicklistAction {
  type: string;
  payload: {
    data?: unknown;
  };
}

export function picklistReducer(
  state: PicklistState = {
    picklist: undefined,
    fetchingPicklist: false,
    fetchPicklistComplete: false,
    fetchPicklistError: undefined,
  },
  action: PicklistAction
) {
  switch (action.type) {
    case GET_PICKLIST:
      return Object.assign({}, state, {
        fetchingPicklist: true,
        fetchPicklistComplete: false,
        picklist: undefined,
      });
    case GET_PICKLIST_SUCCESS:
      return Object.assign({}, state, {
        fetchingPicklist: false,
        fetchPicklistComplete: true,
        picklist: action.payload.data,
      });
    case GET_PICKLIST_ERROR:
      return Object.assign({}, state, {
        fetchingPicklist: false,
        fetchPicklistComplete: true,
        picklist: undefined,
        fetchPicklistError: action.payload.data,
      });
    default:
      return state;
  }
}
